import { PlusCircle } from "lucide-react";

const WorkUnitCreateSkeleton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  return (
    <div className="group relative w-full h-[130px]" onClick={onClick}>
      <div className="block cursor-pointer h-full">
        <div
          className={`flex flex-col items-center justify-center border border-gray-400 dark:border-slate-700 mr-[40px] 
            hover:border-primary-light/50 dark:hover:border-primary-light/50 hover:bg-gray-50 dark:hover:bg-slate-800/50
            transition-all duration-200 rounded-lg overflow-hidden border-l-[4px] h-full border-dashed group`}
        >
          <PlusCircle className="w-10 h-10 text-gray-400 dark:text-slate-600 group-hover:text-primary-light transition-colors duration-200" />
          <div className="mt-2 text-center">
            <p className="text-xs font-semibold text-gray-500 dark:text-slate-400 group-hover:text-primary-light">
              Pin Epic/Feature
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkUnitCreateSkeleton;
